export const openInNewTab = (url: string) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};

type OSType = 'Android' | 'iPhone' | 'Mac' | 'unknown' | 'HUAWEI';
export function getOS() {
  const userAgent = navigator.userAgent;
  let os: OSType = 'unknown';
  // Huawei Phone must come first because its UA also contains "Android"
  if (userAgent.includes('HUAWEI')) os = 'HUAWEI';
  if (userAgent.includes('Android')) os = 'Android';
  if (userAgent.includes('Mac')) os = 'Mac';
  if (userAgent.includes('iPhone')) os = 'iPhone';
  return os;
}

export const isMobile = (): boolean => {
  if (navigator) return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  return false;
};
